module.exports = __webpack_public_path__ + "static/CorrespondentsMexico-d639a7357dd66fb2d8d1687e69f2676b.png";